import {
	usersSuccess,
	usersFailure,
	usersLoading,
	usersUpdating,
	usersUpdatingSuccess,
	usersUpdatingFailure,
	meFailure,
	meSuccess,
	meLoading,
	joiningTeam,
	joinTeamSuccess,
	joinTeamFailure,
	awardsLoadingSuccess,
	awardsLoadingFailure,
	awardsLoading,
	updateSelectedTeam,
	togglingFavoriteTeam,
	togglingFavoriteTeamSuccess,
	togglingFavoriteTeamFailure,
	leavingTeam,
	leaveTeamSuccess,
	leaveTeamFailure,
	newTeamVisitedAction,
	usersDeleting,
	usersDeletingSuccess,
	usersDeletingFailure,
	sendFeedbackSuccess,
	sendFeedbackFailure,
	sendingFeedback,
	acceptingEula,
	accpetEulaFailure,
	accpetEulaSuccess,
	toggleAllNotifications,
	toggleAllNotificationsFailure,
	toggleAllNotificationsSuccess,
	togglePersonalNotifications,
	togglePersonalNotificationsFailure,
	togglePersonalNotificationsSuccess,
	teamSeasonsLoading,
	teamSeasonsSuccess,
	teamSeasonsFailure,
	tourFailure,
	tourSaving,
	tourSuccess,
	deleteTours as deleteToursAction,
	deleteToursFailure,
	deleteToursSuccess,
} from 'redux/actions';
import { getEasterEggsForUser, getEasterEggs } from 'redux/thunks';
import * as requests from 'api/requests';
import { Team } from 'redux/models/team';
import { addErrorToast, addSuccessToast } from 'components/Toast/toastService';
import { TeamUsers } from 'redux/models/teamUsers';
import { Feedback } from 'redux/models/feedback';

export function getUsers(teamId: string, backgroundLoad: boolean = false) {
	return (dispatch: any) => {
		!backgroundLoad && dispatch(usersLoading());

		return requests
			.getUsers(teamId)
			.then(data => {
				dispatch(usersSuccess(data));
			})
			.catch(error => {
				dispatch(usersFailure(error));
			});
	};
}

export function getMe() {
	return (dispatch: any) => {
		dispatch(meLoading());

		return requests
			.getMe()
			.then(data => {
				dispatch(meSuccess(data));
				dispatch(getEasterEggsForUser(data.userId));
				dispatch(getEasterEggs());
			})
			.catch(error => {
				dispatch(meFailure(error));
			});
	};
}

export function getAwardsForUserForTeam(teamId: string, userId: string) {
	return (dispatch: any) => {
		dispatch(awardsLoading());

		return requests
			.getAwardsForUserForTeam(teamId, userId)
			.then(data => {
				dispatch(awardsLoadingSuccess(data));
			})
			.catch(error => {
				dispatch(awardsLoadingFailure(error));
			});
	};
}

export function joinTeam(teamId: string) {
	return (dispatch: any) => {
		dispatch(joiningTeam(teamId));

		return requests
			.joinTeam(teamId)
			.then(data => {
				dispatch(joinTeamSuccess(data));
			})
			.catch(error => {
				dispatch(joinTeamFailure(error));
				addErrorToast(dispatch, 'An error occured while trying to join team. Join unsuccessful.');
			});
	};
}

export function leaveTeam(teamId: string) {
	return (dispatch: any) => {
		dispatch(leavingTeam());

		return requests
			.leaveTeam(teamId)
			.then(data => {
				dispatch(leaveTeamSuccess(teamId));
				addSuccessToast(dispatch, 'You have successfully left the team');
			})
			.catch(error => {
				dispatch(leaveTeamFailure(error));
				addErrorToast(dispatch, 'An error occured while trying to leave team. Leave unsuccessful.');
			});
	};
}

export function selectTeam(teamId: string) {
	return (dispatch: any) => {
		dispatch(updateSelectedTeam(teamId));
	};
}

export function toggleFavoriteTeam(teamId: string) {
	return (dispatch: any) => {
		dispatch(togglingFavoriteTeam());

		return requests
			.favoriteTeam(teamId)
			.then((team: Team) => {
				dispatch(togglingFavoriteTeamSuccess(team));
			})
			.catch(error => {
				dispatch(togglingFavoriteTeamFailure(error));
				addErrorToast(dispatch, 'Something went wrong. Changes were not saved.');
			});
	};
}

export function updateUsers(teamId: string, users: TeamUsers[]) {
	return (dispatch: any) => {
		dispatch(usersUpdating());

		return requests
			.updateUsersByTeam(teamId, users)
			.then((users: TeamUsers[]) => {
				dispatch(usersUpdatingSuccess(users));
				addSuccessToast(dispatch, 'Users successfully updated');
			})
			.catch(error => {
				dispatch(usersUpdatingFailure(error));
				addErrorToast(dispatch, 'Something went wrong. Changes were not saved.');
			});
	};
}

export function deleteUsers(teamId: string, userIds: string[]) {
	return (dispatch: any) => {
		dispatch(usersDeleting());

		return requests
			.deleteUsersByTeam(teamId, userIds)
			.then(() => {
				dispatch(usersDeletingSuccess(userIds));
				addSuccessToast(dispatch, `${userIds.length} team ${userIds.length > 1 ? 'members' : 'member'} successfully removed.`);
			})
			.catch((error: any) => {
				dispatch(usersDeletingFailure(error));
				addErrorToast(dispatch, `Something went wrong while removing team ${userIds.length > 1 ? 'members' : 'member'}. Changes were not saved.`);
			});
	};
}

export function sendFeedback(feedback: Feedback) {
	return (dispatch: any) => {
		dispatch(sendingFeedback());

		return requests
			.sendFeedback(feedback)
			.then(() => {
				dispatch(sendFeedbackSuccess());
				addSuccessToast(dispatch, `Feedback successfully sent`);
			})
			.catch((error: any) => {
				dispatch(sendFeedbackFailure(error));
				addErrorToast(dispatch, 'Something went wrong. Feedback was not sent.');
			});
	};
}

export function acceptEula() {
	return (dispatch: any) => {
		dispatch(acceptingEula());

		return requests
			.acceptEula()
			.then(() => {
				dispatch(accpetEulaSuccess());
				addSuccessToast(dispatch, `Terms of Use accepted.`);
			})
			.catch((error: any) => {
				dispatch(accpetEulaFailure(error));
				addErrorToast(dispatch, 'Something went wrong. Terms of Use was not accepted.');
			});
	};
}

export function toggleAllNotification(teamId: string) {
	return (dispatch: any) => {
		dispatch(toggleAllNotifications());

		return requests
			.toggleAllNotifcations(teamId)
			.then((team: Team) => {
				dispatch(toggleAllNotificationsSuccess(team));
			})
			.catch((error: any) => {
				dispatch(toggleAllNotificationsFailure(error));
				addErrorToast(dispatch, 'Something went wrong. Notification setting not saved.');
			});
	};
}

export function togglePersonalNotification(teamId: string) {
	return (dispatch: any) => {
		dispatch(togglePersonalNotifications());

		return requests
			.togglePersonalNotifcations(teamId)
			.then((team: Team) => {
				dispatch(togglePersonalNotificationsSuccess(team));
			})
			.catch((error: any) => {
				dispatch(togglePersonalNotificationsFailure(error));
				addErrorToast(dispatch, 'Something went wrong. Notification setting not saved.');
			});
	};
}

export function newTeamVisited() {
	return (dispatch: any) => {
		dispatch(newTeamVisitedAction());
	};
}

export function getTeamSeasons(teamId: string) {
	return (dispatch: any) => {
		dispatch(teamSeasonsLoading());

		return requests
			.getSeasonsForTeam(teamId)
			.then(data => {
				dispatch(teamSeasonsSuccess(data));
			})
			.catch(error => {
				dispatch(teamSeasonsFailure(error));
				addErrorToast(dispatch, 'Oh no! An error occured while retrieving seasons for this team.');
			});
	};
}

export function saveTour(tourName: string) {
	return (dispatch: any) => {
		dispatch(tourSaving());

		return requests
			.saveTour(tourName)
			.then(data => {
				dispatch(tourSuccess(tourName));
			})
			.catch(error => {
				dispatch(tourFailure(error));
			});
	};
}

export function deleteTours() {
	return (dispatch: any) => {
		dispatch(deleteToursAction());

		return requests
			.resetTours()
			.then(data => {
				dispatch(deleteToursSuccess());
			})
			.catch(error => {
				dispatch(deleteToursFailure(error));
			});
	};
}
